import { Flex, Text, Link, LinkProps, HTMLChakraProps } from '@chakra-ui/react';
import { TelegramIcon, TwitterIcon } from './SocialMediaIcons';
import { CSSProperties } from 'react';

const LINKS = [
  {
    title: <Text>Docs</Text>,
    href: 'https://docs.variancepoker.xyz/',
  },
  {
    title: <TelegramIcon />,
    href: 'https://t.me/variance_poker_official',
    linkStyle: {
      h: 6,
    },
  },
  {
    title: <TwitterIcon />,
    href: 'https://twitter.com/variance_poker', // TODO
    linkStyle: {
      h: 6,
    },
  },
];

const Footer = ({ linkStyle }: { linkStyle?: CSSProperties }) => {
  return (
    <Flex
      py={8}
      justifyContent={'flex-end'}
      alignItems={'center'}
      gap={8}
      pos={'relative'}
      zIndex={1}
      fontSize={'lg'}
    >
      {LINKS.map(item => (
        <FooterLink
          key={item.href}
          href={item.href}
          {...(item.linkStyle ?? {})}
          style={linkStyle}
        >
          {item.title}
        </FooterLink>
      ))}
    </Flex>
  );
};

const FooterLink = ({ href, children, ...rest }: LinkProps) => (
  <Link
    isExternal
    href={href}
    color={'white'}
    fontWeight={'medium'}
    textDecoration={'none'}
    fontSize={'lg'}
    _hover={{
      color: 'brand',
    }}
    {...rest}
  >
    {children}
  </Link>
);

export default Footer;
